import { render, staticRenderFns } from "./ChatterFileList.vue?vue&type=template&id=4a1e9dd8&scoped=true"
import script from "./ChatterFileList.vue?vue&type=script&lang=js"
export * from "./ChatterFileList.vue?vue&type=script&lang=js"
import style0 from "./ChatterFileList.vue?vue&type=style&index=0&id=4a1e9dd8&prod&lang=css"
import style1 from "./ChatterFileList.vue?vue&type=style&index=1&id=4a1e9dd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1e9dd8",
  null
  
)

export default component.exports